import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { queryClient } from "./lib/queryClient";
import { initSentry } from "./lib/sentry";
import { initI18n, setLazyLoadFailureHandler } from "./lib/i18n";
import { markBuildStale } from "./hooks/useNewVersion";
import "./index.css";

initSentry();
// A locale bundle that 404s means this tab predates the live build; route
// that into the same banner the version poll raises. Must be installed before
// initI18n(), which may already start a lazy load.
setLazyLoadFailureHandler(markBuildStale);
// Must run before the first render: it registers the he/en bundles and sets
// <html lang/dir>, which the very first paint (login screen) already depends on.
initI18n();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
